import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

import PricingPlan from "../../components/PricingPlan/PricingPlan";
import { setPathName, timesheetActivityGroupUrls } from "../../filterReducer";
import { TabButton, TabButtonContainer } from "../../styledComponents/buttons";
import {
  ApprovalFilterContainer,
  CommonGrid,
  Container,
  HorizontalContainer,
  PageTitle,
} from "../../styledComponents/common";
import ApprovalFilter from "./ApprovalFilter/filterContainer";
import ApprovalHistory from "./ApprovalHistory/historyContainer";
import AwaitingApprovals from "./AwaitingApprovals/awaitingApprovalsContainer";
import { StickyFilterContainer } from "../../styledComponents/timesheet";
import { useScrollShadow } from "../../customHooks/useScrollShadow";
import RoundTab from "components/RoundTabButtons/RoundTab";

const TimesheetApproval = ({
  selectedOrganization,
  getTimesheetApprovalAwaitingList,
  getTimesheetApprovalHistory,

  // pagination
  paginationSize,
  loadMoreTimesheetApprovalList,
  clearLoadMoreTimesheetApprovalList,
  filters,
  history,
}) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const showShadow = useScrollShadow(60);
  const [selectedTab, setSelectedTab] = useState("awaiting");

  const [startDate, setStartDate] = useState(
    moment().startOf("week").format("YYYY-MM-DD"),
  );
  const [endDate, setEndDate] = useState(
    moment().endOf("week").format("YYYY-MM-DD"),
  );
  const [dateLabel, setDateLabel] = useState("");
  const [dateChanged, setDateChanged] = useState(false);

  const [sortType, setSortType] = useState({
    value: "oldToNew",
    label: "Date (Old to New)",
  });

  // const [selectedProject, setSelectedProject] = useState("");
  const [selectedMember, setSelectedMember] = useState(
    timesheetActivityGroupUrls.includes(filters?.pathname) &&
      filters?.selectedMember
      ? filters?.selectedMember
      : "",
  );

  // Pricing popup states
  const [pricingPopup, setPricingPopup] = useState(false);
  const [pricingPopupText, setPricingPopupText] = useState(
    "You don't have permission to this feature.",
  );
  const [pricingPopupTitle, setPricingPopupTitle] = useState(
    "Upgrade to paid plan to access this feature",
  );
  const pricingPopupToggle = () => {
    setPricingPopup(!pricingPopup);
  };

  const checkPlanAndShowPopup = () => {
    if (
      selectedOrganization?.plan?.nick_name === "standard-free" ||
      selectedOrganization?.plan?.nick_name === "elite-free"
    ) {
      pricingPopupToggle();
      return false;
    }
    return true;
  };

  // const {
  //   selectedOrganization,
  //   getTimesheetApprovalAwaitingList,
  //   getTimesheetApprovalHistory,

  //   // pagination
  //   paginationSize,
  //   loadMoreTimesheetApprovalList,
  //   clearLoadMoreTimesheetApprovalList,
  //   filters,
  // } = props;

  useEffect(() => {
    dispatch(
      setPathName({
        pathname: location.pathname,
        // selectedTask,
        // selectedProject,
        selectedMember,
        // selectedDate,
        // selectedTimezone,
        // selectedOffice,
      }),
    );
  }, [
    // selectedTask,
    // selectedProject,
    selectedMember,
    // selectedDate,
    // selectedTimezone,
    // selectedOffice,
    dispatch,
    location.pathname,
  ]);
  useEffect(() => {
    if (selectedOrganization && selectedOrganization.id) {
      clearFilters();
    }

    return () => {
      clearLoadMoreTimesheetApprovalList();
    };
  }, [selectedOrganization]);

  useEffect(() => {
    clearFilters();
  }, [selectedTab]);

  const clearFilters = () => {
    // Removed setSelectedMember(''); to preserve the selected member from filters
    setSortType({
      value: "oldToNew",
      label: "Date (Old to New)",
    });
  };

  const changeDateRange = ({ startDate, endDate }) => {
    if (!checkPlanAndShowPopup()) return;
    setStartDate(startDate);
    setEndDate(endDate);
    setDateChanged(!dateChanged); // Added to trigger fetch on date range change
  };
  const getDateLabel = () => {
    const diff = Math.ceil(
      moment(endDate).diff(moment(startDate), "days", true),
    );
    if (
      diff === 0 &&
      moment().format("YYYY-MM-DD") === moment(startDate).format("YYYY-MM-DD")
    ) {
      return "Today selected";
    }
    return diff + 1 + " day" + (diff > 0 ? "s" : "") + " " + "selected";
  };
  const selectLastWeek = () => {
    setStartDate(moment().subtract(6, "days"));
    setEndDate(moment());
    setDateChanged(!dateChanged); // Added to trigger fetch on last week selection
  };
  const selectLastMonth = () => {
    if (!checkPlanAndShowPopup()) return;
    setStartDate(moment().subtract(29, "days"));
    setEndDate(moment());
    setDateChanged(!dateChanged); // Added to trigger fetch on last month selection
  };
  const singleDateChange = direction => {
    if (!checkPlanAndShowPopup()) return;
    if (direction === "right") {
      setStartDate(moment(endDate).add(1, "days"));
      setEndDate(moment(endDate).add(1, "days"));
    } else {
      setStartDate(moment(startDate).subtract(1, "days"));
      setEndDate(moment(startDate).subtract(1, "days"));
    }
    setDateChanged(!dateChanged);
  };
  const selectToday = () => {
    setStartDate(moment());
    setEndDate(moment());
    setDateChanged(!dateChanged);
  };

  // const onDateSelect = () => {
  //   if (selectedOrganization && selectedOrganization.id) {
  //     const payload = {
  //       organization_id: selectedOrganization.id,
  //       start_date: moment(startDate).format('YYYY-MM-DD'),
  //       end_date: moment(endDate).format('YYYY-MM-DD'),
  //       offset: 0,
  //       limit: paginationSize,
  //     };
  //     if (selectedMember && selectedMember.id) {
  //       payload.user_id = selectedMember.id;
  //     }
  //     if (selectedTab === 'awaiting') {
  //       getTimesheetApprovalAwaitingList(payload);
  //     } else {
  //       getTimesheetApprovalHistory(payload);
  //     }
  //     setDateChanged(!dateChanged);
  //   }
  // };

  useEffect(() => {
    if (startDate) {
      if (!endDate) {
        setEndDate(startDate);
      }

      const maxEndDate = moment(startDate).add(3, "months");
      if (
        endDate &&
        moment(endDate).diff(moment(startDate), "months", true) > 3
      ) {
        setEndDate(maxEndDate);
      }

      if (startDate && endDate) {
        setDateLabel(getDateLabel());
      }
    }
  }, [startDate, endDate]);

  const handleDateChange = () => {
    if (selectedOrganization && selectedOrganization.id) {
      const payload = {
        organization_id: selectedOrganization.id,
        start_date: moment(startDate).format("YYYY-MM-DD"),
        end_date: moment(endDate).format("YYYY-MM-DD"),
        offset: 0,
        limit: paginationSize,
      };
      if (selectedMember && selectedMember.id) {
        payload.user_id = selectedMember.id;
      }
      if (selectedTab === "awaiting") {
        getTimesheetApprovalAwaitingList(payload);
      } else {
        getTimesheetApprovalHistory(payload);
      }
    }
  };

  useEffect(() => {
    handleDateChange();
  }, [dateChanged, selectedMember]);

  useEffect(() => {
    if (selectedOrganization?.id) {
      handleDateChange();
    }
  }, [selectedOrganization, selectedTab]);

  const handleSeeMore = (date, currentOffset, type) => {
    if (selectedOrganization && selectedOrganization.id) {
      const payload = {
        organization_id: selectedOrganization.id,
        start_date: moment(date).format("YYYY-MM-DD"),
        end_date: moment(date).format("YYYY-MM-DD"),
        offset: currentOffset,
        limit: paginationSize,
        type,
      };
      loadMoreTimesheetApprovalList(payload);
    }
  };

  const handleTabSelect = tabName => {
    setSelectedTab(tabName);
  };

  const changeSortType = type => {
    setSortType(type);
  };

  return (
    <div className="content">
      <PricingPlan
        isOpen={pricingPopup}
        toggle={pricingPopupToggle}
        popupText={pricingPopupText}
        popupTitle={pricingPopupTitle}
        history={history}
        backRoute={null}
      />
      <PageTitle>Timesheet Approval</PageTitle>
      <StickyFilterContainer paddingBottom="5px" showShadow={showShadow}>
      <HorizontalContainer showShadow={showShadow}  >
        <CommonGrid columns="auto auto" gap="5px">
          <RoundTab text="Awaiting" selected={selectedTab === "awaiting"} onClick={() => handleTabSelect("awaiting")} showIcon={false} />
          <RoundTab text="History" selected={selectedTab === "history"} onClick={() => handleTabSelect("history")} showIcon={false} />
        </CommonGrid>
        {/* <TabButtonContainer width="max-content" disableResponsive margin="30px 0 0 0">
          <TabButton
            selected={selectedTab}
            index={"awaiting"}
            onClick={() => handleTabSelect("awaiting")}
          >
            Awaiting
          </TabButton>
          <TabButton
            selected={selectedTab}
            index={"history"}
            onClick={() => handleTabSelect("history")}
          >
            History
          </TabButton>
        </TabButtonContainer> */}

        <ApprovalFilterContainer>
          <ApprovalFilter
            selectedTab={selectedTab}
            startDate={startDate}
            endDate={endDate}
            dateLabel={dateLabel}
            singleDateChange={singleDateChange}
            selectToday={selectToday}
            onDateSelect={() => {
              setDateChanged(!dateChanged);
            }}
            changeDateRange={changeDateRange}
            selectLastWeek={selectLastWeek}
            selectLastMonth={selectLastMonth}
            sortType={sortType}
            changeSortType={changeSortType}
            selectedMember={selectedMember}
            setSelectedMember={setSelectedMember}
            disableCurrentAndFutureDates
          />
        </ApprovalFilterContainer>
      </HorizontalContainer>
      </StickyFilterContainer>

      {selectedTab && selectedTab === "history" ? (
        <ApprovalHistory
          startDate={startDate}
          endDate={endDate}
          handleSeeMore={handleSeeMore}
        />
      ) : (
        <AwaitingApprovals
          startDate={startDate}
          endDate={endDate}
          handleSeeMore={handleSeeMore}
        />
      )}
    </div>
  );
};

export default TimesheetApproval;
